module.exports = __webpack_public_path__ + "static/media/clientes-logo-02.6d5be3c1.png";